var _rect, _path, _path2, _path3, _rect2, _g, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#594AD7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2714 19.9996H6.72861C5.22396 19.9996 4 18.7757 4 17.2712V6.72842C4 5.22377 5.22392 4 6.72861 4H17.2714C18.776 4 20 5.22391 20 6.72842V17.2717C19.9998 18.7759 18.7757 19.9999 17.2712 19.9999L17.2714 19.9996ZM6.72861 4.5269C5.51496 4.5269 4.52747 5.51426 4.52747 6.72767V17.2709C4.52747 18.4846 5.51482 19.4717 6.72861 19.4717H17.2714C18.485 19.4717 19.4725 18.4843 19.4725 17.2709V6.72814C19.4725 5.51449 18.4852 4.52737 17.2714 4.52737L6.72861 4.52719V4.5269Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6953 7.90137H12.2227V16.2749H11.6953V7.90137Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76953 11.8242H16.1431V12.3516H7.76953V11.8242Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 2,
    fill: "#272727",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_12034_125699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2714 19.9996H6.72861C5.22396 19.9996 4 18.7757 4 17.2712V6.72842C4 5.22377 5.22392 4 6.72861 4H17.2714C18.776 4 20 5.22391 20 6.72842V17.2717C19.9998 18.7759 18.7757 19.9999 17.2712 19.9999L17.2714 19.9996ZM6.72861 4.5269C5.51496 4.5269 4.52747 5.51426 4.52747 6.72767V17.2709C4.52747 18.4846 5.51482 19.4717 6.72861 19.4717H17.2714C18.485 19.4717 19.4725 18.4843 19.4725 17.2709V6.72814C19.4725 5.51449 18.4852 4.52737 17.2714 4.52737L6.72861 4.52719V4.5269Z",
    fill: "#594AD7"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2714 19.9996H6.72861C5.22396 19.9996 4 18.7757 4 17.2712V6.72842C4 5.22377 5.22392 4 6.72861 4H17.2714C18.776 4 20 5.22391 20 6.72842V17.2717C19.9998 18.7759 18.7757 19.9999 17.2712 19.9999L17.2714 19.9996ZM6.72861 4.5269C5.51496 4.5269 4.52747 5.51426 4.52747 6.72767V17.2709C4.52747 18.4846 5.51482 19.4717 6.72861 19.4717H17.2714C18.485 19.4717 19.4725 18.4843 19.4725 17.2709V6.72814C19.4725 5.51449 18.4852 4.52737 17.2714 4.52737L6.72861 4.52719V4.5269Z",
    stroke: "#594AD7",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6953 7.90137H12.2227V16.2749H11.6953V7.90137Z",
    fill: "#594AD7",
    stroke: "#594AD7",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76953 11.8242H16.1431V12.3516H7.76953V11.8242Z",
    fill: "#594AD7",
    stroke: "#594AD7",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_12034_125699",
    x: 3,
    y: 3,
    width: 18,
    height: 22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_12034_125699"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectMedia);
export default __webpack_public_path__ + "static/media/selectMedia.3a7f8bc528b89b30501bddcf7b0b29c8.svg";
export { ForwardRef as ReactComponent };